<template>
  <div class="avecor-table" >
    <v-toolbar dense style="border-top:1px solid #ccc;position:fixed;top:70px;width:100%;background:#FFF !important;z-index:20"  flat class="pr-4">
      <v-toolbar-title >Tukkurit</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-col cols="2">
        <v-text-field
          :value="wholesaleCompaniesSearch"
          @change="(event) => wholesaleCompaniesSearch = event"
          class="table-search avecor-select"
          label="Etsi tukkureita (nimi, koodi)"
          single-line
          hide-details
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn @click="addWholesaleCompanyDialog=true" dark class="avecor-button-global add-button mb-2" color="#000000">Lisää tukkuri</v-btn>
      <AddWholesaleCompany @close="addWholesaleCompanyDialog=false" :visible="addWholesaleCompanyDialog" ></AddWholesaleCompany>
    </v-toolbar>
    <WholesaleCompanyExpand 
      v-if="selectedWholesaleCompanyId ? true : false" 
      location="partners" 
    ></WholesaleCompanyExpand>
    <v-container class="" fluid px-0 py-2 ma-0 style="position:absolute; top:85px; width:100%;border-top:1px solid #ccc;background:#EEEEEE;">
      <v-row no-gutters>
        <v-col cols="6">
          <v-row no-gutters>
            <v-col class="orders-custom-header pr-1" cols="1"></v-col>
            <v-col cols="2" class="orders-custom-header">Lisätty pvm.</v-col>
            <!-- <v-col cols="1" class="orders-custom-header pl-0 pr-2 blue--text" style="text-decoration:underline;cursor:pointer;" @click="sortColumn = 'wholesaleCode'; sortAsc = !sortAsc">Avecor koodi</v-col> -->
            <v-col cols="2" class="orders-custom-header pl-0 blue--text" style="text-decoration:underline;cursor:pointer;" @click="sortColumn = 'name'; sortAsc = !sortAsc">Tukun nimi</v-col>
            <v-col cols="1" class="orders-custom-header pl-0">Kieli</v-col>
            <v-col cols="2" class="orders-custom-header pl-0">www-osoite</v-col>
            <v-col cols="1" class="orders-custom-header pl-0 text-center">linkki</v-col>
            <v-col cols="2" class="orders-custom-header pl-0">toinen www-osoite</v-col>
            <v-col cols="1" class="orders-custom-header pl-0 text-center">linkki</v-col>
          </v-row>
        </v-col>
        <v-col cols="6" class="pl-3">
          <v-row no-gutters>
            <!-- <v-col cols="1" class="orders-custom-header pl-0">Tuotteet hinnastossa</v-col> -->
            <v-col cols="2" class="orders-custom-header pl-0">Käyttäjätunnus</v-col>
            <v-col cols="1" class="orders-custom-header pl-0">Salasana</v-col>
            <v-col cols="2" class="orders-custom-header pl-0">Tilaussähköposti</v-col>
            <v-col cols="2" class="orders-custom-header pl-0">Yhteyshenkilöt</v-col>
            <v-col cols="5" class="orders-custom-header pl-0">Kommentit/Ohjeet</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid ma-0 px-0 pt-0 style="height:100%;position:absolute; overflow:scroll;top:116px; padding-bottom:600px; width:100%; border-top:1px solid #ccc;">
      <!-- min-height:50px; -->
      <v-lazy
        style="width:100%; padding:0px; margin:0px; border-bottom:1px solid #ccc;"
        :options="{
          threshold: .1
        }"
        v-for="(wc) in getWholesaleCompanies"
        :key="'wc-'+wc.id"
      >
        <v-row class="" no-gutters  style="width:100%; ">
          <v-col cols="6" style="">
            <v-row  no-gutters>
              <v-col cols="1" class="pt-0 pl-3" >
                <div class="pt-1">
                  <v-icon :size="10" @click="selectedWholesaleCompanyId = wc.id;" style="padding-right:5px;">far fa-eye</v-icon>
                  <v-tooltip top >
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <v-icon :size="10" v-if="!wc.productsInCatalog" @click="toggleProductsInCatalog(wc.id,true)" style="padding-right:5px;">fas fa-money-check-alt</v-icon>
                        <v-icon :size="10" v-else @click="toggleProductsInCatalog(wc.id,false)" style="padding-right:5px;color:green">fas fa-money-check-alt</v-icon>
                      </span>
                    </template>
                    <span>Vaihda tuotteet hinnastossa tilaa päälle ja pois. Jos väri on vihreä, tuotteet löytyvät hinnastossa.</span>
                  </v-tooltip>
                  <v-icon :size="10" v-if="allAccess" @click="deleteItem(wc)">far fa-trash-alt</v-icon>
                  <!-- <v-icon :size="10" v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" @click="deleteItem(wc)">far fa-trash-alt</v-icon> -->
                </div>
              </v-col>
              <v-col cols="2" class="pt-0 pr-1"><div class="stock-custom-field">{{customFormatter(wc.created_at)}}</div></v-col>
              <!-- <v-col cols="1" class="pt-0 pr-2"><div class="stock-custom-field">{{wc.wholesaleCode}}</div></v-col> -->
              <v-col cols="2" class="pt-0 pr-2" ><div class="stock-custom-field">{{wc.name}}</div></v-col>
              <v-col cols="1" class="pt-0 pr-2" ><div class="stock-custom-field">{{wc.language}}</div></v-col>
              <v-col cols="2" class="pt-0 pr-2" ><div class="stock-custom-field">{{wc.webAddress}}</div></v-col>
              <v-col cols="1" class="pt-0 text-center" >
                <v-btn v-if="wc.webAddress !== undefined && wc.webAddress !== ''" :href="wc.webAddress !== undefined && wc.webAddress.includes('http') ? wc.webAddress : 'http://' + wc.webAddress" text target="_blank">
                  <v-icon size=10>fas fa-external-link-alt</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="2" class="pt-0 pr-2" ><div class="stock-custom-field">{{wc.webAddress2}}</div></v-col>
              <v-col cols="1" class="pt-0 " >
                <v-btn v-if="wc.webAddress2" :href="wc.webAddress2 !== undefined && wc.webAddress2.includes('http') ? wc.webAddress2 : 'http://'+wc.webAddress2" text target="_blank">
                  <v-icon size=10>fas fa-external-link-alt</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="pl-3">
            <v-row  no-gutters>
              <!-- <v-col cols="1" class="pl-3"><div class="stock-custom-field">{{wc.productsInCatalog}}</div></v-col> -->
              <v-col cols="2" class="pl-2"><div class="stock-custom-field">{{wc.username}}</div></v-col>
              <v-col cols="1" class="pl-2"><div class="stock-custom-field">{{wc.password}}</div></v-col>
              <v-col cols="2" class="pl-2"><div class="stock-custom-field">{{wc.orderEmail}}</div></v-col>
              <v-col cols="2" class="pl-2">
                <div class="stock-custom-field" v-if="wc.partnerContacts">
                  <div  :key="pcKey" v-for="(pcKey,i) in Object.keys(wc.partnerContacts)">
                    <div>{{wc.partnerContacts[pcKey].firstName + ' ' + wc.partnerContacts[pcKey].lastName}}</div>
                    <div>{{wc.partnerContacts[pcKey].phone ? wc.partnerContacts[pcKey].phone : ''}}</div>
                    <div>{{wc.partnerContacts[pcKey].email}}</div>
                    <div v-if="Object.keys(wc.partnerContacts).length > 1 && i !== Object.keys(wc.partnerContacts).length-1">-------------------------------</div>
                  </div>
                </div>

              </v-col>
              <v-col cols="4" class="pl-3"><div class="stock-custom-field"><pre  style="white-space: pre-wrap;">{{wc.comments}}</pre></div></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-lazy>
    </v-container>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import AddWholesaleCompany from './AddWholesaleCompany'
import WholesaleCompanyExpand from './WholesaleCompanyExpand'

export default {
    components: {
      AddWholesaleCompany,
      WholesaleCompanyExpand
    },
    data: () => ({
      sortColumn:'name',
      //sortColumn:'wholesaleCode',
      sortAsc:true,
      isEditing: false,
      selected: ["Avecor Oy"],
      selections: {},
      dialog: false,
      wholesaleCompaniesSearch: '',
      addWholesaleCompanyDialog: false,
      selectedOrderId: null,
      selectedProductId: null,
      table: null,
      search: '',
      editedIndex: -1,
      addedDatePickerMenuMaster: false,
      newItem: {
        productName: 'Kynät',
        categoryTags: [],
        netvisorId: '',
        unitPurchasePrice: 1,
      },
      defaultItem: {
        productName: 'Kynät',
        categoryTags: [],
        netvisorId: '',
        unitPurchasePrice: 1,
      },
      latestToCustomerDatePickerMenu: false,
      date: new Date().toISOString().substr(0, 10)
    }),
    watch: {
    },
    mounted() {
      const table = this.$refs.table
    },
    computed: {
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getWholesaleCompanies(){
        var selectedWholesaleCompanies = []
        Object.keys(this.wholesaleCompanies).forEach(key => {
          var wc = this.wholesaleCompanies[key]
          if (this.wholesaleCompaniesSearch !== ""){
              var wholesaleCompanyTextsToSearch = ""
              if(wc.name !== undefined) wholesaleCompanyTextsToSearch += wc.name
              
              if(wc.id !== undefined) wholesaleCompanyTextsToSearch += wc.id
              if(wc.wholesaleCode !== undefined) wholesaleCompanyTextsToSearch += wc.wholesaleCode
              if(wholesaleCompanyTextsToSearch.toLowerCase().includes(this.wholesaleCompaniesSearch.toLowerCase())) selectedWholesaleCompanies.push(wc)
          }
          else {
            selectedWholesaleCompanies.push(wc)
          }
        })
        var sortedWholesaleCompanies
        if(this.sortColumn ==='name'){
          sortedWholesaleCompanies = selectedWholesaleCompanies.sort((a,b)=>{
            var nameA=a.name.toLowerCase().trim(), nameB=b.name.toLowerCase().trim();
            if(this.sortAsc){
              if (nameA > nameB) {return 1;}
              if (nameB > nameA) {return -1;}
              return 0;
            }
            else{
              if (nameA < nameB) {return 1;}
              if (nameB < nameA) {return -1;}
              return 0;
            }
          })
        }
        else if (this.sortColumn === 'wholesaleCode'){
          sortedWholesaleCompanies = selectedWholesaleCompanies.sort((a,b)=>{
            
            var nameA=a.wholesaleCode ? a.wholesaleCode.trim() : '', nameB=b.wholesaleCode ? b.wholesaleCode.trim() : '';
            if(this.sortAsc){
              if (nameA > nameB) {return 1;}
              if (nameB > nameA) {return -1;}
              return 0;
            }
            else{
              if (nameA < nameB) {return 1;}
              if (nameB < nameA) {return -1;}
              return 0;
            }
          })
        }

        return sortedWholesaleCompanies
      },
      getProducts(){
        var products = this.products
        return Object.keys(this.products).map(function(key, index) {
          var o = products[key]
          return {...o}
        })
      },
      getOrders(){
        var orders = this.orders
        return Object.keys(this.orders).map(function(key, index) {
          var o = orders[key]
          return {...o}
        })
      },
      getCompanies(){
        var companies = this.companies
        return Object.keys(this.companies).map(function(key, index) {
          var c = companies[key]
          return {text: c.companyName, value: c.id}
        })
      },
      getSalespeople(){
        var staff = this.staff
        return Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if (s.roles.includes("sales")) return {text: s.firstName, value: s.id} 
        })
      },
      ...mapFields({
        settings:"settings",
        user:"user",
        products:'product.products',
        wholesaleCompanies:'wholesaleCompany.wholesaleCompanies',
        wholesaleCompaniesSearchTerm:"settings.wholesaleCompaniesSearchTerm",
        companies:"company.companies",
        staff:"staff.staff",
        orders:"order.orders",
        selectedWholesaleCompanyId:"views.partners.selectedWholesaleCompany.wholesaleCompanyId"
      })
      
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      
    },

    methods: {
      toggleProductsInCatalog(id,onOff){
        this.$store.dispatch('wholesaleCompany/set', {
          id,
          productsInCatalog:onOff
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        )
      },
      disabledRoleSelection (id){
          if (id === "y9ZVH4HpzFWuS9TzONQUJadQZ4T2" || id === "p2VRFkTz4JUzqkGoTPUt4CWQAxa2") return true
          else return false
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      editItem (item) {
        this.editedIndex = this.products.indexOf(item)
        this.newItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        if (confirm('HUOM. ÄLKÄÄ POISTAKO JOS TUOTTEILLE KÄYTETTY TÄTÄ TUKKURIA. POISTAKAA VAIN JOS VIRHEELLISESTI LISÄTTY!')) {
              if(item.id === this.selectedWholesaleCompanyId) this.selectedWholesaleCompanyId = ""
              this.$store.dispatch('wholesaleCompany/delete', item.id)
        }
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      getContactsList(partnerContacts){
        var contactText = ''
        if (partnerContacts === undefined) return contactText
        console.log(partnerContacts)
        Object.keys(partnerContacts).forEach(key => {
          contactText !== '' ? contactText += '<br>' : ''
          contactText += partnerContacts[key].firstName + ' ' +  partnerContacts[key].lastName + ' ' + partnerContacts[key].phone + ' ' + partnerContacts[key].email
        })
        return contactText
      },
      inlineSave (item) {
        let {id, ...y} = item;
        this.$store.dispatch('wholesaleCompany/set', {
          id,
          ...y
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          )
        
      },
      inlineSaveField(id,field,value){
        this.$store.dispatch('wholesaleCompany/set', {
          id,
          [field]:value
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        )
        
        /* this.$store.dispatch('order/set', {
          id:orderId,
          [field]:value
        })
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}) */
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/WholesaleCompaniesTable.vue